import {Component,OnInit} from "@angular/core";
import {TypeCompteApi} from "@components/admin/parametre/api/rest/api-rest-details/api-rest-details.component";
import {ApiRestDetailsService} from "@components/admin/parametre/api/rest/api-rest-details/api-rest-details.service";
import {TranslateService} from "@ngx-translate/core";

/**
 * Onglet Compte
 *
 * @author Guillaume TRAVOT
 * @date 26/11/2025
 */
@Component({
    selector: 'api-rest-details-compte',
    host: {'data-test-id': 'api-rest-details-compte'},
    templateUrl: './api-rest-details-compte.component.html'
})
export class ApiRestDetailsCompteComponent implements OnInit {
    /** Déclaration pour le template */
    protected readonly TypeCompteApi = TypeCompteApi;

    /** Liste des types possibles */
    listeTypesPossibles: {code: string, libelle: string}[];

    /**
     * Constructeur
     */
    constructor(
        protected apiRestDetailsService: ApiRestDetailsService,
        private translateService: TranslateService) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Peuplement de la liste des types possibles
        this.listeTypesPossibles = [{
            code: TypeCompteApi.PERSONNEL,
            libelle: this.translateService.instant('admin.parametres.api.rest.details.compte.comptePerso')
        },{
            code: TypeCompteApi.SERVICE,
            libelle: this.translateService.instant('admin.parametres.api.rest.details.compte.compteService')
        }];
    }
}